import React from "react";
import "./PanelRow.css";

/**
 * iCRAFTZ Design System · <PanelRow>
 *
 * A row in the right-hand Homepage info panel. Icon on the left,
 * title + one-line description on the right.
 *
 * Props
 * ─────
 * icon         React element
 * title        Row title (e.g. "AI-Curated Wisdom Artifacts")
 * description  One-line description
 * href / onClick  optional interactive target
 */
export function PanelRow({
  icon,
  title,
  description,
  href,
  onClick,
  className = "",
  ...rest
}) {
  const interactive = !!(href || onClick);
  const Tag = href ? "a" : interactive ? "button" : "div";
  return (
    <Tag
      className={[
        "icz-panel-row",
        interactive ? "icz-panel-row--interactive" : "",
        className,
      ].filter(Boolean).join(" ")}
      href={href}
      onClick={onClick}
      type={Tag === "button" ? "button" : undefined}
      {...rest}
    >
      {icon ? (
        <span className="icz-panel-row__icon" aria-hidden="true">{icon}</span>
      ) : null}
      <span className="icz-panel-row__text">
        <span className="icz-panel-row__title">{title}</span>
        {description ? (
          <span className="icz-panel-row__desc">{description}</span>
        ) : null}
      </span>
    </Tag>
  );
}

export default PanelRow;
